import { NgModule } from "@angular/core";
import { RouterModule, Routes } from "@angular/router";
import { AuthGuard, FeatureGuard } from "../services/permission/permissions.service";
import { AdministrationComponent } from "./administration.component";
import { UsersComponent } from "./users/users.component";
import { UserComponent } from "./users/user/user.component";
import { AccessRequestManagementComponent } from "./access-request-management/access-request-management.component";
import { RunnersAdminComponent } from "./runners/runners.component";
import { RunnerAdminComponent } from "./runners/runner/runner.component";
import { OrgUnitsComponent } from "./org-units/org-units.component";
import { UserDataTypesComponent } from "./userdata-types/userdata-types.component";
import { UserDataTypeDetailComponent } from "./userdata-types/userdata-type-detail.component";
import { IpBlacklistComponent } from "./ip-blacklist/ip-blacklist.component";
import { CapabilitiesComponent } from "./capabilities/capabilities.component";
import { CapabilityDetailComponent } from "./capabilities/capability-detail.component";
import { ReferenceDataComponent } from "./reference-data/reference-data.component";
import { ReferenceDataBucketsComponent } from "./reference-data/reference-data-buckets.component";
import { ReferenceDataEditComponent } from "@nucleus/reference-data-ui";
import { ConnectorsComponent } from "./connectors/connectors.component";
import { ConnectorEditComponent } from "@nucleus/connector-admin-ui";



const routes: Routes = [
  {
    path: "administration",
    component: AdministrationComponent,

    children: [
      {
        path: "users",
        component: UsersComponent,
        canActivate: [AuthGuard]
      },
      {
        path: "user",
        component: UserComponent,
        canActivate: [AuthGuard]
      },
      {
        path: "user/:id",
        component: UserComponent,
        canActivate: [AuthGuard]
      },
      {
        path: "access-request-management",
        component: AccessRequestManagementComponent,
        canActivate: [AuthGuard]
      },
      {
        path: "org-units",
        component: OrgUnitsComponent,
        canActivate: [AuthGuard, FeatureGuard('org-units')]
      },
      {
        path: "userdata-types",
        component: UserDataTypesComponent,
        canActivate: [AuthGuard, FeatureGuard('userdata-types')]
      },
      {
        path: "userdata-types/:type",
        component: UserDataTypeDetailComponent,
        canActivate: [AuthGuard, FeatureGuard('userdata-types')]
      },
      {
        path: "runners",
        component: RunnersAdminComponent,
        canActivate: [AuthGuard]
      },
      {
        path: "runner/:id",
        component: RunnerAdminComponent,
        canActivate: [AuthGuard]
      },
      {
        path: "ip-blacklist",
        component: IpBlacklistComponent,
        canActivate: [AuthGuard]
      },
      {
        path: "capabilities",
        component: CapabilitiesComponent,
        canActivate: [AuthGuard]
      },
      {
        path: "capabilities/:code/:version",
        component: CapabilityDetailComponent,
        canActivate: [AuthGuard]
      },
      {
        path: "reference-data",
        component: ReferenceDataBucketsComponent,
        canActivate: [AuthGuard]
      },
      {
        path: "reference-data/:bucket",
        component: ReferenceDataComponent,
        canActivate: [AuthGuard]
      },
      {
        path: "reference-data/:bucket/new",
        component: ReferenceDataEditComponent,
        canActivate: [AuthGuard]
      },
      {
        path: "reference-data/:bucket/:id",
        component: ReferenceDataEditComponent,
        canActivate: [AuthGuard]
      },
      {
        path: "connectors",
        component: ConnectorsComponent,
        canActivate: [AuthGuard]
      },
      {
        path: "connectors/new",
        component: ConnectorEditComponent,
        canActivate: [AuthGuard]
      },
      {
        path: "connectors/:id",
        component: ConnectorEditComponent,
        canActivate: [AuthGuard]
      }
    ]
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class AdministrationRoutingModule {}
